import { Component, Inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { AlertSettings, DistributionProfileSummary, Reference } from 'src/app/hickory-api';
import { ConfirmComponent, ConfirmData } from 'src/app/shared/modals/confirm/confirm.component';
import { parseUrlPath } from 'src/app/shared/model/utility';

@Component({
  selector: 'app-recipient-details-adhoc',
  templateUrl: './recipient-details-adhoc.component.html',
  styleUrls: ['./recipient-details-adhoc.component.scss'],
  standalone: false
})
export class RecipientDetailsAdhocComponent {
  @Input() alert: AlertSettings;
  @Input() distributionList: DistributionProfileSummary;

  // ROAD-9840 todo - we need a way to tell what kind of sources are present
  get adHocSources(): Reference[] { return this.distributionList?.sources?.filter(s => s.uri?.endsWith('.csv')); }

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private dialog: MatDialog,
  ) { }

  getFileName(source: Reference): string {
    const path = parseUrlPath(source?.uri);
    const parts = path?.split('/') ?? ['unknown'];
    return parts[parts?.length - 1];
  }

  getToolTip(_source: Reference): string {
    const recipientCount = this.distributionList?.recipientCount ?? 0;
    const errorCount = this.distributionList?.errorCount ?? 0;
    return `Recipients: ${recipientCount || 'None'}; Errors: ${errorCount || 'None'}`;
  }

  onSourceClick(source: Reference) {
    const uri = source?.uri;
    if (!uri) return;
    const data: ConfirmData = { title: this.getFileName(source), message: 'Do you want to download this source file?', }
    this.dialog.open(ConfirmComponent, { data: data, minWidth: '400px', }).afterClosed().subscribe(result => {
      if (!result) return;
      window.open(uri, "_blank");
    });

  }
}

